/**
 * Supabase Client Configuration
 * 
 * Centralized Supabase client initialization.
 * Uses environment variables for configuration.
 */

import { createClient } from '@supabase/supabase-js';

// Validate environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase environment variables are not set. ' +
    'Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  );
}

// Create and export Supabase client
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: false, // Disable session persistence for now
  },
});

// Export configuration for testing/debugging
export const config = {
  url: supabaseUrl,
  hasValidConfig: !!(supabaseUrl && supabaseAnonKey),
};

